import * as React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import moment from "moment";
import { RFTfeature } from "../features/RFTfeature";

export default function TableComponent({ headRow, rows, tableBody, saleType }) {
  const companyCode = localStorage.getItem("companyCode");
  const getValue = (row, body) => {
    if (RFTfeature()) {
      if (saleType == "serviceRFT" || saleType == "RFT" || saleType == "Role") {
        let value = row[body];

        if (body == "change" || body == "newValue" || body == "oldValue") {
          value = parseFloat(value).toFixed(2);
        }
        if (body == "created_at") {
          return moment.unix(value).format("DD-MM-YYYY hh:mm:ss a");
        } else {
          return value;
        }
      } else {
        let value = row[body];
        if (body == "change" || body == "newValue" || body == "oldValue") {
          value = parseFloat(value).toFixed(2);
        }
        if (body == "created_at") {
          return moment.unix(value).format("DD-MM-YYYY hh:mm:ss a");
        } else {
          return value;
        }
      }
    } else {
      let value = row[body];
      if (body == "created_at") {
        return moment.unix(value).format("DD-MM-YYYY hh:mm:ss a");
      } else {
        return value;
      }
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 550 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {headRow.map((item, i) => (
              <TableCell key={i}>{item} </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {tableBody.map((body, i) => (
                <TableCell key={i} component="th" scope="row">
                  {getValue(row, body)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
